"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldSelector = void 0;
var React = require("react");
var Treeview_1 = require("../Treeview");
var Field_1 = require("./components/Field");
var Folder_1 = require("./components/Folder");
var MainTable_1 = require("./components/MainTable");
var SearchArea_1 = require("./components/SearchArea");
var FieldSelector_context_1 = require("./FieldSelector.context");
var FieldSelector_styles_1 = require("./FieldSelector.styles");
var FieldSelector = function (props) {
    var _a = React.useState(""), searchString = _a[0], setSearchString = _a[1];
    var handleOnSearch = function (search) {
        return props.OnSearch(search).then(function () {
            setSearchString(search);
        });
    };
    var handleOnClearSearch = function () {
        return props.OnClearSearch().then(function () {
            setSearchString("");
        });
    };
    return (React.createElement(FieldSelector_context_1.FieldSelectorProvider, { value: {
            CanEditCriteriaFeature: props.CanEditCriteriaFeature,
            CurrentSearchString: searchString,
            Data: props.Data,
            OnAddFavourite: props.OnAddFavourite,
            OnAddField: props.OnAddField,
            OnDeleteLinkFieldClick: props.OnDeleteLinkFieldClick,
            OnDuplicate: props.OnDuplicate,
            OnDuplicateByCriteria: props.OnDuplicateByCriteria,
            OnDuplicateByField: props.OnDuplicateByField,
            OnDuplicateTableEditCriteria: props.OnDuplicateTableEditCriteria,
            OnInsertFunction: props.OnInsertFunction,
            OnLinkFieldClick: props.OnLinkFieldClick,
            OnRemoveDuplicateTable: props.OnRemoveDuplicateTable,
            OnRemoveFavourite: props.OnRemoveFavourite,
            OnRenameDuplicateTable: props.OnRenameDuplicateTable,
        } },
        React.createElement(FieldSelector_styles_1.Wrapper, null,
            React.createElement(MainTable_1.MainTable, { MainTableValue: props.MainTableValue, MainTables: props.MainTables, OnMainTableChange: props.OnMainTableChange }),
            React.createElement(SearchArea_1.SearchArea, { OnSearch: handleOnSearch, OnClearSearch: handleOnClearSearch }),
            React.createElement("div", null,
                React.createElement(Treeview_1.Treeview, { Data: props.Data, OnDataRequest: props.OnDataRequest, RenderFolder: function (item) { return React.createElement(Folder_1.Folder, { Item: item }); }, RenderItem: function (Item, ref) { return React.createElement(Field_1.Field, { Item: Item, ref: ref }); } })))));
};
exports.FieldSelector = FieldSelector;
